import React from "react";
import {Route, Switch} from "react-router-dom";

// Components
import CandidateList from "./CandidateList";
import CandidateView from "./CandidateView";
import CandidateEdit from "./CandidateEdit";
import CandidateContributedWeeks from "./CandidateContributedWeeks";

const Candidates = () => {
    return (
        <Switch>
            <Route path={"/dashboard/candidatos"} exact>
                <CandidateList/>
            </Route>
            <Route path={"/dashboard/candidatos/ver"} exact>
                <CandidateView/>
            </Route>
            <Route path={"/dashboard/candidatos/editar"} exact>
                <CandidateEdit/>
            </Route>
            <Route path={"/dashboard/candidatos/semanas-cotizadas"} exact>
                <CandidateContributedWeeks/>
            </Route>
        </Switch>
    )
}

export default Candidates